import React from 'react';
import { Col, Form, FormGroup, Input, InputGroup } from 'reactstrap';

import { validateEmail as validateE } from '../../../utils/validateEmail';
import InvitationSent from './invitationSent.jsx';

class InviteAFriendView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      alertBox: false,
      success: false,
      validate: {
        emailState: false,
      },
    };
    this.validateEmail = this.validateEmail.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
  }

  validateEmail(e) {
    const { validate } = this.state;
    validate.emailState = validateE(e);
    this.setState({ validate });
  }

  handleCloseAlert() {
    this.setState({ alertBox: false });
  }

  handleEmailChange = (event) => {
    const emailValid = document.querySelector('#email').validity.valid;
    this.setState({ email: event.target.value, emailValid });
  };

  disableEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.sendFriendsRequestMessage.text !== '') {
      this.hideMessage(this.props.setSendFriendRequestMessage);
    }
  }

  hideMessage = (functionParam) => {
    setTimeout(() => {
      functionParam({ type: 'success', text: '' });
    }, 3000);
  };

  handleSendInvitation = () => {
    this.props.sendFriendsRequest(this.state.email);
  };

  sendFriendRequest = () => {
    const emailValid = document.querySelector('#email').validity.valid;

    if (emailValid) {
      this.props.sendFriendsRequest(this.state.friendEmail);
      this.setState({ friendEmailValid: true });
      this.props.setSendFriendRequestMessage({ type: 'error', text: '' });
    } else {
      this.props.setSendFriendRequestMessage({
        type: 'error',
        text: 'Invalid email address',
      });
      this.setState({ friendEmailValid: false });
    }
  };

  sendAnotherFriendRequest = () => {
    this.props.setSendFriendRequestSuccess(false);
    this.setState({
      email: '',
      emailValid: false,
    });
  };

  render() {
    const email = this.state.email;
    if (!this.props.sendFriendsRequestSuccess) {
      return (
        <div className="invite-friend-container text-center">
          <Col xs={12} className="p-0">
            {this.props.message && this.props.message !== '' && (
              <div
                className={this.state.alertBox ? 'alert' : 'd-none'}
                role="alert"
              >
                <i onClick={this.handleCloseAlert} className="icon-close" />
                <p className="description">{this.props.message}</p>
              </div>
            )}
          </Col>
          <Col xs={12} className="p-0">
            <Form role="form">
              <FormGroup className="mb-3">
                <InputGroup>
                  <Input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Enter Friend’s Email"
                    value={email}
                    valid={this.state.emailValid}
                    invalid={!this.state.emailValid}
                    onChange={this.handleEmailChange}
                    onKeyPress={this.disableEnter}
                  />
                </InputGroup>
              </FormGroup>
            </Form>
            <button
              disabled={!this.state.emailValid}
              className="w-100 btn"
              onClick={this.handleSendInvitation}
            >
              SEND INVITATION
            </button>
            {this.props.sendFriendsRequestMessage.text !== '' &&
              this.props.sendFriendsRequestMessage.type === 'error' && (
                <span className="message-error">
                  {this.props.sendFriendsRequestMessage.text}
                </span>
              )}
          </Col>
        </div>
      );
    }
    return (
      <div className="invite-friend-container container text-center">
        <InvitationSent onClick={this.sendAnotherFriendRequest} />
      </div>
    );
  }
}

export default InviteAFriendView;
